import { useEffect } from "react";
import { initCookieConsent } from "../../utils/cookieConsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "./CookieConsent.css";

export function CookieConsentInit() {
  useEffect(() => {
    initCookieConsent();
  }, []);

  return null;
}
